/**
 * @fileoverview Speed Dial item schema for user-configurable quick navigation
 * actions displayed in a floating speed dial component.
 */

import { z } from 'zod';
import { commonValidators, createCrudSchemas, createEntityIdSchema, createdAtSchema, deletedAtSchema, getSchemaFields, updatedAtSchema } from './base.js';
import { ID_PATTERNS } from './types.js';

export const SpeedDialItemSchema = z.object({
  id: createEntityIdSchema(ID_PATTERNS.SPEED_DIAL_ITEM, 'ID must be in sd-prefixed nanoid7 format'),
  label: commonValidators.requiredString('Label', 100),
  icon_name: z.string().max(50).default('Link'),
  route_path: commonValidators.requiredString('Route Path', 255),
  display_order: commonValidators.displayOrder(),
  is_enabled: commonValidators.booleanWithDefault(true),
  metadata: commonValidators.jsonField('Metadata'),
  deleted_at: deletedAtSchema,
  created_at: createdAtSchema,
  updated_at: updatedAtSchema,
});

const { CreateSchema, UpdateSchema } = createCrudSchemas(SpeedDialItemSchema);

export const SpeedDialItemCreateSchema = CreateSchema;
export const SpeedDialItemUpdateSchema = UpdateSchema;

export type SpeedDialItem = z.infer<typeof SpeedDialItemSchema>;
export type SpeedDialItemCreate = z.infer<typeof SpeedDialItemCreateSchema>;
export type SpeedDialItemUpdate = z.infer<typeof SpeedDialItemUpdateSchema>;

export const SPEED_DIAL_ITEM_FIELDS = getSchemaFields(SpeedDialItemSchema);

